import type { Logout } from 'flowhawk-core';
import type { Reducer } from '@reduxjs/toolkit';
import type { MemberProfileV2, UserProfile } from '../Utils/types';
import type { ResetData } from './ApplicationActions';

export type AddPeopleResult = { user: UserProfile };
export type AddPeopleError = { error: string };
export type EmptyObject = {};
export type AddPeopleType = AddPeopleResult | AddPeopleError | EmptyObject;

export type AddPeopleState = {
  selectedUsers: (UserProfile | MemberProfileV2)[];
};

const initialState: AddPeopleState = {
  selectedUsers: [],
};

export type SetSelectedUsers = { type: 'AddPeople/SET_SELECTED_USERS'; users: (UserProfile | MemberProfileV2)[] };
export type ResetAddPeople = { type: 'AddPeople/RESET' };
export type AddPeopleInvite = {
  type: 'AddPeople/INVITE_NEW_USER';
  email?: string;
  phone?: string;
  firstName: string;
  lastName: string;
  organization?: string;
  organizationId?: number;
  department?: string;
};

type Action = ResetData | Logout | SetSelectedUsers | ResetAddPeople | AddPeopleInvite;

export const setSelectedUsers = (users: (UserProfile | MemberProfileV2)[]): SetSelectedUsers => ({
  type: 'AddPeople/SET_SELECTED_USERS',
  users,
});
export const resetAddPeople = (): ResetAddPeople => ({
  type: 'AddPeople/RESET',
});
export const inviteNewUser = (
  email?: string,
  phone?: string,
  firstName: string = '',
  lastName: string = '',
  organization?: string,
  organizationId?: number,
  department?: string,
): AddPeopleInvite => ({
  type: 'AddPeople/INVITE_NEW_USER',
  email,
  phone,
  firstName,
  lastName,
  organization,
  organizationId,
  department,
});

const reducer = (state: AddPeopleState = initialState, action: Action): AddPeopleState => {
  switch (action.type) {
    case 'Application/RESET_DATA':
    case 'AddPeople/RESET':
    case 'Auth/LOGOUT':
      // Reset to initial state when logging out or resetting
      return {
        ...initialState,
      };

    case 'AddPeople/SET_SELECTED_USERS':
      return {
        ...state,
        selectedUsers: action.users,
      };

    default:
      return state;
  }
};

export default reducer as Reducer<AddPeopleState>;
